import React from "react";

const colorMap = {
    blue: {
        border: "rgba(6, 182, 212, 0.28)",
        bg: `
          radial-gradient(540px 240px at 12% 12%, rgba(6, 182, 212, 0.11), transparent 54%),
          radial-gradient(440px 220px at 88% 18%, rgba(59, 130, 246, 0.035), transparent 50%),
          linear-gradient(135deg, rgba(4, 11, 24, 0.18), rgba(2, 6, 23, 0.08))
        `,
    iconColor: "rgba(6, 182, 212, 0.95)",
    iconBg: "rgba(6, 182, 212, 0.10)",
    iconBorder: "rgba(6, 182, 212, 0.22)",
  },
  green: {
    border: "rgba(16, 185, 129, 0.28)",
    bg: `
      radial-gradient(540px 240px at 12% 12%, rgba(16, 185, 129, 0.10), transparent 54%),
      radial-gradient(440px 220px at 88% 18%, rgba(6, 182, 212, 0.03), transparent 50%),
      linear-gradient(135deg, rgba(4, 11, 24, 0.18), rgba(2, 6, 23, 0.08))
    `,
    iconColor: "rgba(16, 185, 129, 0.95)",
    iconBg: "rgba(16, 185, 129, 0.10)",
    iconBorder: "rgba(16, 185, 129, 0.22)",
  },
  amber: {
    border: "rgba(245, 158, 11, 0.28)",
    bg: `
      radial-gradient(540px 240px at 12% 12%, rgba(245, 158, 11, 0.10), transparent 54%),
      radial-gradient(440px 220px at 88% 18%, rgba(236, 72, 153, 0.03), transparent 50%),
      linear-gradient(135deg, rgba(4, 11, 24, 0.18), rgba(2, 6, 23, 0.08))
    `,
    iconColor: "rgba(245, 158, 11, 0.95)",
    iconBg: "rgba(245, 158, 11, 0.10)",
    iconBorder: "rgba(245, 158, 11, 0.22)",
  },
  purple: {
    border: "rgba(139, 92, 246, 0.28)",
    bg: `
      radial-gradient(540px 240px at 12% 12%, rgba(139, 92, 246, 0.10), transparent 54%),
      radial-gradient(440px 220px at 88% 18%, rgba(6, 182, 212, 0.03), transparent 50%),
      linear-gradient(135deg, rgba(4, 11, 24, 0.18), rgba(2, 6, 23, 0.08))
    `,
    iconColor: "rgba(139, 92, 246, 0.95)",
    iconBg: "rgba(139, 92, 246, 0.10)",
    iconBorder: "rgba(139, 92, 246, 0.22)",
  },
  teal: {
    border: "rgba(6, 182, 212, 0.26)",
    bg: `
      radial-gradient(540px 240px at 12% 12%, rgba(6, 182, 212, 0.09), transparent 54%),
      radial-gradient(440px 220px at 88% 18%, rgba(16, 185, 129, 0.03), transparent 50%),
      linear-gradient(135deg, rgba(4, 11, 24, 0.18), rgba(2, 6, 23, 0.08))
    `,
    iconColor: "rgba(103, 232, 249, 0.98)",
    iconBg: "rgba(6, 182, 212, 0.10)",
    iconBorder: "rgba(6, 182, 212, 0.20)",
  },
  navy: {
    border: "rgba(59, 130, 246, 0.26)",
    bg: `
      radial-gradient(540px 240px at 12% 12%, rgba(59, 130, 246, 0.085), transparent 54%),
      radial-gradient(440px 220px at 88% 18%, rgba(139, 92, 246, 0.03), transparent 50%),
      linear-gradient(135deg, rgba(4, 11, 24, 0.18), rgba(2, 6, 23, 0.08))
    `,
    iconColor: "rgba(96, 165, 250, 0.98)",
    iconBg: "rgba(59, 130, 246, 0.10)",
    iconBorder: "rgba(59, 130, 246, 0.20)",
  },
  pink: {
    border: "rgba(236, 72, 153, 0.28)",
    bg: `
      radial-gradient(540px 240px at 12% 12%, rgba(236, 72, 153, 0.10), transparent 54%),
      radial-gradient(440px 220px at 88% 18%, rgba(139, 92, 246, 0.03), transparent 50%),
      linear-gradient(135deg, rgba(4, 11, 24, 0.18), rgba(2, 6, 23, 0.08))
    `,
    iconColor: "rgba(244, 114, 182, 0.98)",
    iconBg: "rgba(236, 72, 153, 0.10)",
    iconBorder: "rgba(236, 72, 153, 0.20)",
  },
};

export default function KpiCard({
  title,
  value,
  sub,
  chip,
  chipAction = false,
  icon: Icon,
  color = "blue",
}) {
  const c = colorMap[color] || colorMap.blue;

  return (
    <div
      className="dashboard-kpiCard"
      style={{
        borderColor: c.border,
        background: c.bg,
      }}
    >
      <div className="dashboard-kpiCardGlow" />

      <div className="dashboard-kpiCardTop">
        <div className="dashboard-kpiCardLeft">
          <div
            className="dashboard-kpiCardIcon"
            style={{
              color: c.iconColor,
              background: c.iconBg,
              borderColor: c.iconBorder,
            }}
          >
            <Icon size={17} />
          </div>

          <div className="dashboard-kpiCardTitle">{title}</div>
        </div>

        {chip ? (
          <div
            className={`dashboard-kpiCardChip ${
              chipAction ? "isAction" : ""
            }`}
          >
            {chip}
          </div>
        ) : null}
      </div>

      <div className="dashboard-kpiCardValue">{value}</div>

      {sub ? <div className="dashboard-kpiCardSub">{sub}</div> : null}
    </div>
  );
}